import { StateCreator } from 'zustand';

import { SidebarShellStore } from './types';
import { SIDEBAR_OPEN_STORAGE_KEY } from '../../constants/sidebar';

// sessionStorage directly, not the IndexedDB persist adapter: the flag must be
// readable synchronously at module scope (before first paint) and must not
// survive across tabs/devices, so `persist` + createIndexedDBStorage doesn't fit.
function readStoredOpen(): boolean {
  if (typeof window === 'undefined') {
    return true;
  }

  const stored = window.sessionStorage.getItem(SIDEBAR_OPEN_STORAGE_KEY);
  if (stored === null) {
    return true;
  }

  try {
    return JSON.parse(stored) as boolean;
  } catch {
    return true;
  }
}

function writeStoredOpen(isOpen: boolean): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.sessionStorage.setItem(
    SIDEBAR_OPEN_STORAGE_KEY,
    JSON.stringify(isOpen),
  );
}

export const createSidebarShellSlice: StateCreator<SidebarShellStore> = (
  set,
) => ({
  isOpen: readStoredOpen(),
  toggle: () =>
    set((state) => {
      const next = !state.isOpen;
      writeStoredOpen(next);
      return { isOpen: next };
    }),
  setOpen: (isOpen) => {
    writeStoredOpen(isOpen);
    set({ isOpen });
  },
});
